import { Component, OnInit, Inject } from '@angular/core';
import { ConfirmBoxModel } from './confirm-box.model';
import { UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationManager } from '../notification-manager';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-confirm-box',
    templateUrl: './confirm-box.component.html',
    styleUrl: './confirm-box.component.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, TextFieldModule, ReactiveFormsModule, MatButtonModule, PreventDoubleClickDirective]
})
export class ConfirmBoxDialog implements OnInit {
    model: ConfirmBoxModel;
    public REASON_MAX_SIZE = 100;
    ValidReasonMaxLength = new UntypedFormControl('', [Validators.maxLength(this.REASON_MAX_SIZE)]);

    constructor(
        public dialogRef: MatDialogRef<ConfirmBoxDialog>,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmBoxModel) {
        this.model = Object.assign({}, data);
    }

    ngOnInit() {
        if (this.data.WithLengthValidation) {
            this.ValidReasonMaxLength.markAsTouched();
        }
    }

    canSave() {
        if (this.model.WithReason) {
            if (!this.model.Reason) {
                return false;
            }
        }
        return true;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (!this.canSave()) {
            NotificationManager.handleWarning('Veuillez entrer une raison.', this.snackBar);
            return;
        }
        this.dialogRef.close(this.model);
    }
}
